module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-map-panel\">\n	<div class=\"title\">Данные за выбранный период</div>\n	<div class=\"row\">Пробег: <span>")
    ; __append(escapeFn( mileage ))
    ; __append(" км</span></div>\n	<div class=\"row\">Средняя скорость: <span>")
    ; __append(escapeFn( speed ))
    ; __append("</span> км/ч</div>\n</div>\n")
  }
  return __output.join("");

}